import { render, staticRenderFns } from "./InvoiceDialog.vue?vue&type=template&id=32645397&"
import script from "./InvoiceDialog.vue?vue&type=script&lang=js&"
export * from "./InvoiceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports